import React from 'react';
import { useTranslation } from 'react-i18next';
import './Home.css';

function Home() {
  const { t } = useTranslation();

  return (
    <div className="home">
      <header className="hero" id="home">
        <div className="container">
          <h1 className="hero-title">{t('hero.title')}</h1>
          <p className="hero-subtitle">{t('hero.subtitle')}</p>
          <div className="cta-buttons">
            <a href="#download" className="btn btn-primary">{t('hero.downloadBtn')}</a>
            <a href="#features" className="btn btn-secondary">{t('hero.learnMore')}</a>
          </div>
        </div>
      </header>

      <section id="features" className="features">
        <div className="container">
          <h2 className="section-title">{t('features.title')}</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎙️</div>
              <h3>{t('features.voiceRecording.title')}</h3>
              <p>{t('features.voiceRecording.description')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>{t('features.emotionalTracking.title')}</h3>
              <p>{t('features.emotionalTracking.description')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📖</div>
              <h3>{t('features.journal.title')}</h3>
              <p>{t('features.journal.description')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🕌</div>
              <h3>{t('features.dhikr.title')}</h3>
              <p>{t('features.dhikr.description')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⏰</div>
              <h3>{t('features.reminders.title')}</h3>
              <p>{t('features.reminders.description')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🌙</div>
              <h3>{t('features.interface.title')}</h3>
              <p>{t('features.interface.description')}</p>
            </div>
          </div>
        </div>
      </section>

      <section id="pricing" className="pricing">
        <div className="container">
          <h2 className="section-title">{t('pricing.title')}</h2>
          <p className="pricing-subtitle">{t('pricing.subtitle')}</p>
          <div className="pricing-grid">
            <div className="pricing-card">
              <h3>{t('pricing.free.title')}</h3>
              <div className="price">
                <span className="amount">{t('pricing.free.price')}</span>
                <span className="period">{t('pricing.free.period')}</span>
              </div>
              <ul className="features-list">
                {t('pricing.free.features', { returnObjects: true }).map((feature, index) => (
                  <li key={index}>✓ {feature}</li>
                ))}
              </ul>
              <a href="#download" className="pricing-btn">{t('pricing.free.button')}</a>
            </div>

            <div className="pricing-card">
              <h3>{t('pricing.monthly.title')}</h3>
              <div className="price">
                <span className="amount">{t('pricing.monthly.price')}</span>
                <span className="period">{t('pricing.monthly.period')}</span>
              </div>
              <ul className="features-list">
                {t('pricing.monthly.features', { returnObjects: true }).map((feature, index) => (
                  <li key={index}>✓ {feature}</li>
                ))}
              </ul>
              <a href="#download" className="pricing-btn pricing-btn-primary">{t('pricing.monthly.button')}</a>
            </div>

            <div className="pricing-card pricing-card-popular">
              <div className="popular-badge">{t('pricing.lifetime.save')}</div>
              <h3>{t('pricing.lifetime.title')}</h3>
              <div className="price">
                <span className="amount">{t('pricing.lifetime.price')}</span>
                <span className="period">{t('pricing.lifetime.period')}</span>
              </div>
              <ul className="features-list">
                {t('pricing.lifetime.features', { returnObjects: true }).map((feature, index) => (
                  <li key={index}>✓ {feature}</li>
                ))}
              </ul>
              <a href="#download" className="pricing-btn pricing-btn-primary">{t('pricing.lifetime.button')}</a>
            </div>
          </div>
          <p className="pricing-note">{t('pricing.note')}</p>
        </div>
      </section>

      <section id="download" className="download">
        <div className="container">
          <h2 className="section-title">{t('download.title')}</h2>
          <p className="download-text">{t('download.subtitle')}</p>
          <div className="store-buttons">
            <a href="#" className="store-btn">
              <img
                src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg"
                alt="Download on App Store"
              />
            </a>
            <a href="#" className="store-btn">
              <img
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Get it on Google Play"
              />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
